import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "filter-bar" }
const _hoisted_2 = { class: "filter-bar__left" }
const _hoisted_3 = { class: "dropdowns" }
const _hoisted_4 = { class: "search" }

import { computed } from "vue";
import { useStore } from "vuex";
import { watchDebounced } from "@vueuse/core";

import Checkbox from "@/components/px-checkbox/px-checkbox.vue";
import RangeSelector from "./range-selector.vue";
import FacetSearchDropdown from "./facet-search-dropdown.vue";
import { EMatchingSearchActions } from "@/modules/matching/services/store/matching-search/matching-search.types";


export default /*@__PURE__*/_defineComponent({
  __name: 'main',
  setup(__props) {

const store = useStore();

const vilLevel = computed(() => store.state.matchingSearch.filters.vil);
const sortOrder = computed(() => store.state.matchingSearch.filters.sort);
const searchQuery = computed(() => store.state.matchingSearch.filters.query);
const loadingFacet = computed(() => store.state.matchingSearch.loadingFacet);

const foundingDateFacetQuery = computed(
  () => store.state.matchingSearch.filters.foundingDateFacetQuery,
);
const sectorsFacetQuery = computed(
  () => store.state.matchingSearch.filters.sectorsFacetQuery,
);
const countriesFacetQuery = computed(
  () => store.state.matchingSearch.filters.countriesFacetQuery,
);

// Prepare Facet Filter Options
const sectors = computed(() => {
  return store.state.matchingSearch.facets?.sectors?.options.map(
    (option: any) => {
      return {
        component: Checkbox,
        props: {
          key: option.value,
          value: option.value,
          label: `${option.label} (${option.count})`,
          checked: store.state.matchingSearch.filters.sectors.includes(
            option.value,
          ),
        },
        listeners: {
          change: () => {
            store.dispatch(EMatchingSearchActions.SET_FILTERS, {
              filter: "sectors",
              action: "update",
              value: option.value,
            });
          },
        },
      };
    },
  );
});
const countries = computed(() => {
  return store.state.matchingSearch.facets?.countries?.options.map(
    (option: any) => ({
      component: Checkbox,
      props: {
        key: option.value,
        label: `${option.label} (${option.count})`,
        value: option.value,
        checked: store.state.matchingSearch.filters.countries.includes(
          option.value,
        ),
      },
      listeners: {
        change: () => {
          store.dispatch(EMatchingSearchActions.SET_FILTERS, {
            filter: "countries",
            action: "update",
            value: option.value,
          });
        },
      },
    }),
  );
});
const foundingDates = computed(() => {
  return store.state.matchingSearch.facets?.founding_date?.options.map(
    (option: any) => ({
      component: Checkbox,
      props: {
        key: option.value,
        value: option.value,
        label: `${option.label === "0" ? "No Founding Date" : option.label} (${option.count})`,
        checked: store.state.matchingSearch.filters.founding_date.includes(
          option.value,
        ),
      },
      listeners: {
        change: () => {
          store.dispatch(EMatchingSearchActions.SET_FILTERS, {
            filter: "founding_date",
            action: "update",
            value: option.value,
          });
        },
      },
    }),
  );
});

// Update Facet Filter Selections
const updateSectorsQuery = (value: string) => {
  store.dispatch(EMatchingSearchActions.SET_FILTERS, {
    filter: "sectorsFacetQuery",
    action: "update",
    value: value,
  });
};
const updateCountriesQuery = (value: string) => {
  store.dispatch(EMatchingSearchActions.SET_FILTERS, {
    filter: "countriesFacetQuery",
    action: "update",
    value: value,
  });
};
const updateFoundingDateQuery = (value: string) => {
  store.dispatch(EMatchingSearchActions.SET_FILTERS, {
    filter: "foundingDateFacetQuery",
    action: "update",
    value: value,
  });
};
const updateSearchQuery = (value: string) => {
  store.dispatch(EMatchingSearchActions.SET_FILTERS, {
    filter: "query",
    action: "update",
    value: value,
  });
};
const updateSortOrder = (order: string) => {
  store.dispatch(EMatchingSearchActions.SET_FILTERS, {
    filter: "sort",
    action: "update",
    value: order,
  });
};
const updateLevel = (value: number[]) => {
  store.dispatch(EMatchingSearchActions.SET_FILTERS, {
    filter: "vil",
    action: "update",
    value: value,
  });
};

// Clear Facet Filters
const clearSectorsFacet = () => {
  store.dispatch(EMatchingSearchActions.SET_FILTERS, {
    filter: "sectors",
    action: "clear",
    value: [],
  });
};
const clearCountriesFacet = () => {
  store.dispatch(EMatchingSearchActions.SET_FILTERS, {
    filter: "countries",
    action: "clear",
    value: [],
  });
};
const clearFoundingDateFacet = () => {
  store.dispatch(EMatchingSearchActions.SET_FILTERS, {
    filter: "founding_date",
    action: "clear",
    value: [],
  });
};
const clearAllFilters = () => {
  console.log("triggered");
  store.dispatch(EMatchingSearchActions.SET_FILTERS, {
    filter: "all",
    action: "clear",
  });
};

watchDebounced(
  sectorsFacetQuery,
  () => {
    store.dispatch(EMatchingSearchActions.SEARCH_FILTERS, {
      facet: "sectors",
      query: sectorsFacetQuery.value,
    });
  },
  { debounce: 500, maxWait: 1000 },
);
watchDebounced(
  countriesFacetQuery,
  () => {
    store.dispatch(EMatchingSearchActions.SEARCH_FILTERS, {
      facet: "countries",
      query: countriesFacetQuery.value,
    });
  },
  { debounce: 500, maxWait: 1000 },
);
watchDebounced(
  foundingDateFacetQuery,
  () => {
    store.dispatch(EMatchingSearchActions.SEARCH_FILTERS, {
      facet: "founding_date",
      query: foundingDateFacetQuery.value,
    });
  },
  { debounce: 500, maxWait: 1000 },
);
watchDebounced(
  searchQuery,
  () => {
    store.dispatch(EMatchingSearchActions.SEARCH, "search");
  },
  { debounce: 500 },
);

return (_ctx: any,_cache: any) => {
  const _component_PxButton = _resolveComponent("PxButton")!
  const _component_PxIcon = _resolveComponent("PxIcon")!
  const _component_ElInput = _resolveComponent("ElInput")!
  const _component_ElTag = _resolveComponent("ElTag")!
  const _component_ElDropdownItem = _resolveComponent("ElDropdownItem")!
  const _component_ElDropdownMenu = _resolveComponent("ElDropdownMenu")!
  const _component_ElDropdown = _resolveComponent("ElDropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "title" }, "Filters", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(RangeSelector, {
          value: vilLevel.value,
          onUpdateRange: updateLevel
        }, null, 8, ["value"]),
        _createVNode(FacetSearchDropdown, {
          title: "HQ Country",
          options: countries.value,
          loading: loadingFacet.value,
          "has-search": true,
          query: countriesFacetQuery.value,
          "search-placeholder": "Search Countries",
          onUpdateQuery: updateCountriesQuery,
          onClearAllFilters: clearCountriesFacet
        }, null, 8, ["options", "loading", "query"]),
        _createVNode(FacetSearchDropdown, {
          title: "Sectors",
          options: sectors.value,
          loading: loadingFacet.value,
          "has-search": true,
          query: sectorsFacetQuery.value,
          "search-placeholder": "Search Sectors",
          onUpdateQuery: updateSectorsQuery,
          onClearAllFilters: clearSectorsFacet
        }, null, 8, ["options", "loading", "query"]),
        _createVNode(FacetSearchDropdown, {
          options: foundingDates.value,
          title: "Founded Date",
          loading: loadingFacet.value,
          "has-search": true,
          query: foundingDateFacetQuery.value,
          "search-placeholder": "Search Year",
          onUpdateQuery: updateFoundingDateQuery,
          onClearAllFilters: clearFoundingDateFacet
        }, null, 8, ["options", "loading", "query"]),
        _createVNode(_component_PxButton, {
          size: "small",
          onClick: clearAllFilters
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode(" Clear All Filters ", -1)
          ]))]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_ElInput, {
        clearable: "",
        "model-value": searchQuery.value,
        placeholder: "Search name, sectors, countries, regions, cities",
        onInput: updateSearchQuery
      }, {
        prefix: _withCtx(() => [
          _createVNode(_component_PxIcon, {
            size: 24,
            name: "magnifier"
          })
        ]),
        _: 1
      }, 8, ["model-value"]),
      _createVNode(_component_ElDropdown, { placement: "bottom-start" }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_ElDropdownMenu, null, {
            default: _withCtx(() => [
              _createVNode(_component_ElDropdownItem, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (updateSortOrder('desc')))
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode(" Latest Assessment First ", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_ElDropdownItem, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (updateSortOrder('asc')))
              }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode(" Oldest Assessment First ", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_ElTag, {
            type: "primary",
            effect: "plain"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Sort By (" + _toDisplayString(sortOrder.value === "desc" ? "Latest" : "Oldest") + ") ", 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})